"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ContentLine_1 = require("../../contentLine/ContentLine");
var core_1 = require("@material-ui/core");
var ComplexVehicleSummary = function (_a) {
    var bodyStyleTrimShortname = _a.bodyStyleTrimShortname, nameplate = _a.nameplate, engineTitle = _a.engineTitle, specPackTitle = _a.specPackTitle, interior = _a.interior, exterior = _a.exterior, vehicleDisplayName = _a.vehicleDisplayName;
    var _b;
    var _c = ((_b = core_1.useTheme().checkoutLite) === null || _b === void 0 ? void 0 : _b.summary) || {}, hideVehicleSummary = _c.hideVehicleSummary, hideSpecPackTitle = _c.hideSpecPackTitle, showVehicleColors = _c.showVehicleColors, showVehicleDisplayNameInSummary = _c.showVehicleDisplayNameInSummary;
    return (<>
      {showVehicleDisplayNameInSummary && vehicleDisplayName ? (<ContentLine_1.default mainContent={vehicleDisplayName} dataTest="summary:vehicle:vehicleDisplayName"/>) : (<>
          {!hideVehicleSummary && bodyStyleTrimShortname && (<ContentLine_1.default mainContent={nameplate} dataTest="summary:vehicle:nameplate"/>)}
          {nameplate && (<ContentLine_1.default mainContent={bodyStyleTrimShortname} dataTest="summary:vehicle:body_style_trim_shortname"/>)}
          {engineTitle && <ContentLine_1.default mainContent={engineTitle} dataTest="summary:vehicle:engine_title"/>}
          {!hideSpecPackTitle && specPackTitle && (<ContentLine_1.default mainContent={specPackTitle} dataTest="summary:vehicle:speck_pack_title"/>)}
        </>)}
      {showVehicleColors && (<>
          {exterior && <ContentLine_1.default mainContent={exterior} dataTest="summary:vehicle:exterior"/>}
          {interior && <ContentLine_1.default mainContent={interior} dataTest="summary:vehicle:interior"/>}
        </>)}
    </>);
};
exports.default = ComplexVehicleSummary;
